export default __webpack_public_path__ + "static/media/ig-3.0c17e07d.jpg";